<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { EvalModelEditorViewModel } from '@Evaluation/EvaluationModels/Components/EvalModelEditor';

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class EvalModelEditor extends Vue
    {
        get vm(): EvalModelEditorViewModel { return this.$props.viewModel as EvalModelEditorViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }
        get operationInProgress(): boolean { return this.vm.operationInProgress; }

        get goalError(): string | null { return this.vm.errors.length ? this.vm.errors[0].Error : null; }
        get goalName(): string | null { return this.vm.name; }
        set goalName(val: string | null) { this.vm.name = val; }

        handleFormSubmit()
        {
            this.vm.operationInProgress = true;
            this.vm.clearValidationErrors();
            this.$emit('update-evalmodel', this.vm.id, this.goalName);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Edit goal</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">                        
                        <form id="evalmodel-editor-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Goal name:</label>
                                <input v-model.trim="goalName" type="text" class="form-control" required minlength="2" maxlength="100">
                                <small class="text-danger">{{goalError}}</small>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close"  class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="evalmodel-editor-form" :disabled="operationInProgress"  class="btn btn-primary">
                            <span v-if="operationInProgress"><i class="fa fa-spinner fa-spin"></i> Please wait...</span>
                            <span v-if="!operationInProgress">Update</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>